// Recurrence op lokale kalenderdatums (ONTWERP.md §5): bron van waarheid = wandkloktijd + zone,
// nooit UTC. De generator rekent uitsluitend met datums `{y,m,d}`; tijd-van-de-dag en zone worden
// pas bij het afleiden van occurrences/instants gekoppeld (occurrences.ts, time/zone.ts).
//
// Pure functies zonder runtime-afhankelijkheden (geen Luxon, geen Zod): de ouderapp gebruikt de
// NL-samenvatting live in de herhaling-editor, de server gebruikt dezelfde code voor expansie.
// Alleen ES2018-API's: de kiosk-tsconfig typecheckt deze module mee via type-imports.
export const WEEKDAYS = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
export const FREQUENCIES = ['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];
export class RecurrenceError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'RecurrenceError';
    }
}
/** Harde bovengrens op gegenereerde slots per aanroep, tegen runaway-regels. */
export const MAX_OCCURRENCES_PER_EXPANSION = 5000;
/** Harde bovengrens op bekeken kandidaat-datums (DAILY vanaf 1990 met COUNT, enz.). */
export const MAX_CANDIDATES_PER_EXPANSION = 200_000;
/** Begrensd venster (§5.2, CAL-19): 1 jaar terug, 2 jaar vooruit t.o.v. vandaag. */
export const EXPANSION_DAYS_BACK = 366;
export const EXPANSION_DAYS_AHEAD = 731;
/** Grootste toegestane COUNT in de UI (ruim; "na N keer"). */
export const MAX_COUNT = 1000;
//# sourceMappingURL=types.js.map